import { render, staticRenderFns } from "./FilterRuleTable.vue?vue&type=template&id=0806c7e5&"
import script from "./FilterRuleTable.vue?vue&type=script&lang=js&"
export * from "./FilterRuleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports